import { MessageCircle } from "lucide-react";
import { buildWhatsAppUrl } from "@/lib/utm";

const marcas = ["Dickson", "Naizil", "Polyfab", "Sioen", "Serge Ferrari", "Waterproof", "Verseidag"];

// Paleta oficial FlexShade (5 colores de línea)
const colores = [
  { name: "Negro", hex: "#111111" },
  { name: "Desert Sun", hex: "#C88A5C" },
  { name: "Aquatic Blue", hex: "#2C6E91" },
  { name: "Steel Grey", hex: "#6B7280" },
  { name: "Brunswick Green", hex: "#1B4D3E" },
];

export default function Materials() {
  const wa = buildWhatsAppUrl(
    "5218116289267",
    "Hola Eclipse, quiero ver muestras fisicas de materiales y colores FlexShade."
  );
  return (
    <section id="materiales" className="bg-white py-20 md:py-28">
      <div className="container-x">
        <div className="text-center mb-12">
          <span className="eyebrow">Materiales Premium</span>
          <h2 className="mt-4 section-title text-4xl md:text-6xl font-black">
            Materiales importados de <span className="text-red-600">primera calidad</span>
          </h2>
          <p className="mt-4 text-neutral-600 max-w-2xl mx-auto">
            Trabajamos solo con las marcas más reconocidas del mundo en tensoestructuras.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-neutral-50 rounded-2xl p-6 border border-neutral-200">
            <h3 className="font-black text-xl mb-2 section-title">Mallasombra arquitectónica</h3>
            <p className="text-neutral-600 text-sm mb-4">Importada, con protección UV 95% y garantía hasta 20 años.</p>
            <div className="flex flex-wrap gap-2">
              {marcas.slice(0,4).map((m) => (
                <span key={m} className="text-xs font-semibold bg-white px-3 py-1.5 rounded-full border border-neutral-200">{m}</span>
              ))}
            </div>
          </div>
          <div className="bg-neutral-50 rounded-2xl p-6 border border-neutral-200">
            <h3 className="font-black text-xl mb-2 section-title">Membrana PVC impermeable</h3>
            <p className="text-neutral-600 text-sm mb-4">100% impermeable, ideal para zonas con lluvias intensas.</p>
            <div className="flex flex-wrap gap-2">
              {marcas.slice(3).map((m) => (
                <span key={m} className="text-xs font-semibold bg-white px-3 py-1.5 rounded-full border border-neutral-200">{m}</span>
              ))}
            </div>
          </div>
          <div className="bg-orange-50 rounded-2xl p-6 border border-orange-200">
            <h3 className="font-black text-xl mb-2 section-title text-orange-900">Garantía por escrito</h3>
            <p className="text-orange-800 text-sm mb-4">Desde 10 hasta 20 años en todos nuestros productos. Respaldada por Eclipse.</p>
            <p className="text-5xl font-black text-orange-600 section-title">10–20<span className="text-2xl"> años</span></p>
          </div>
        </div>

        <div className="mt-14">
          <h3 className="text-center section-title text-2xl md:text-3xl font-black mb-2">Colores de línea FlexShade</h3>
          <p className="text-center text-sm text-neutral-500 mb-8">5 acabados oficiales disponibles en nuestra línea arquitectónica.</p>
          <div className="flex flex-wrap gap-6 md:gap-10 justify-center max-w-4xl mx-auto" data-testid="colores-linea">
            {colores.map((c) => (
              <div key={c.name} className="flex flex-col items-center" data-testid={`color-${c.name.toLowerCase().replace(/\s+/g,'-')}`}>
                <div
                  className="w-16 h-16 md:w-20 md:h-20 rounded-full shadow-lg ring-4 ring-white border border-neutral-200"
                  style={{ backgroundColor: c.hex }}
                  title={c.name}
                />
                <span className="text-xs md:text-sm text-neutral-700 mt-3 font-semibold">{c.name}</span>
              </div>
            ))}
          </div>
          <p className="text-center text-xs text-neutral-500 mt-8">* Colores sujetos a disponibilidad. Solicita tu muestra física con un asesor.</p>
          <div className="text-center mt-5">
            <a href={wa} target="_blank" rel="noreferrer" className="btn-wa px-6 py-3 rounded-xl inline-flex items-center gap-2">
              <MessageCircle className="w-5 h-5" /> Quiero ver muestras de material
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
